<app-header [header]="$safeNavigationMigration(landing.value()?.header)" />

<main class="app-main">
    <router-outlet />
</main>

<app-footer [footer]="$safeNavigationMigration(landing.value()?.footer)" />
